(function () {
  'use strict';

  if (window.CustoGiftsFooterV11) {
    window.CustoGiftsFooterV11.sync(document);
    return;
  }

  var mobileQuery = window.matchMedia('(max-width: 749px)');

  function footerMenus(scope) {
    var menus = [];
    var root = scope || document;
    if (root.matches && root.matches('.footer-menu')) menus.push(root);
    if (root.querySelectorAll) {
      root.querySelectorAll('.footer-menu').forEach(function (menu) { menus.push(menu); });
    }
    return menus;
  }

  function syncFooterMenus(scope) {
    footerMenus(scope).forEach(function (menu) {
      var summary = menu.querySelector('summary');
      if (mobileQuery.matches) {
        if (summary) {
          summary.removeAttribute('tabindex');
          summary.removeAttribute('aria-disabled');
        }
        if (menu.dataset.mobileTouched !== 'true') menu.open = false;
      } else {
        menu.open = true;
        if (summary) {
          summary.setAttribute('tabindex', '-1');
          summary.setAttribute('aria-disabled', 'true');
        }
        delete menu.dataset.mobileTouched;
      }
    });
  }

  window.CustoGiftsFooterV11 = { sync: syncFooterMenus };

  document.addEventListener('toggle', function (event) {
    if (!mobileQuery.matches || !event.target.matches('.footer-menu')) return;
    event.target.dataset.mobileTouched = 'true';
  }, true);

  if (typeof mobileQuery.addEventListener === 'function') {
    mobileQuery.addEventListener('change', function () { syncFooterMenus(document); });
  } else if (typeof mobileQuery.addListener === 'function') {
    mobileQuery.addListener(function () { syncFooterMenus(document); });
  }

  document.addEventListener('shopify:section:load', function (event) {
    syncFooterMenus(event.target);
  });

  syncFooterMenus(document);
})();
